/**
 * Legacy URLs: /{labId}/... -> /maptac/{labId}/...
 * Returns a router next() target or null (no redirect).
 * Must run before auth checks (same hook as createAuthGuard).
 */
export function getLegacyToMaptacLocation(to) {
  if (to.path === '/maptac') {
    return { path: '/maptac/login', query: to.query, hash: to.hash, replace: true }
  }
  if (to.path.startsWith('/maptac/')) return null
  if (to.path === '/') return null
  const segments = to.path.split('/').filter(Boolean)
  const first = segments[0]
  if (!first) return null
  if (first === 'login') return null
  if (first === 'assets' || first === 'api') return null
  if (first === 'auth' && segments[1] === 'callback' && segments.length === 2) {
    return null
  }
  return {
    path: `/maptac/${segments.join('/')}`,
    query: to.query,
    hash: to.hash,
    replace: true
  }
}

/**
 * `redirect` query and session targets should use /maptac/... even if a cached bundle
 * produced legacy /:labId paths.
 * Strips `?` and `#` (Vue `fullPath` can include them), re-appends after normalizing the path.
 */
export function ensureMaptacFullPathForRedirect(path) {
  if (path == null || path === '' || path === '/') return path
  const q = path.indexOf('?')
  const h = path.indexOf('#')
  const pathEnd = [q, h].filter((i) => i >= 0)
  const cut = pathEnd.length ? Math.min(...pathEnd) : path.length
  const onlyPath = path.slice(0, cut)
  const rest = path.slice(cut)

  if (onlyPath === '/maptac' || onlyPath.startsWith('/maptac/')) {
    return onlyPath + rest
  }
  if (onlyPath === '/login' || onlyPath.startsWith('/auth/callback')) {
    return onlyPath + rest
  }
  if (onlyPath.startsWith('/assets/') || onlyPath.startsWith('/api/')) {
    return onlyPath + rest
  }
  const clean = onlyPath.startsWith('/') ? onlyPath : `/${onlyPath}`
  const normalized = (`/maptac${clean}`).replace(/\/+/g, '/')
  return normalized + rest
}

/**
 * Lab UI lives under /maptac/:labId/...
 * Normalize backend redirect_path (may be legacy /{lab_id}) after login / SSO.
 */
export function normalizePostAuthLabPath(raw) {
  if (raw == null || typeof raw !== 'string') return null
  const trimmed = raw.trim()
  if (!trimmed) return null
  const withLeading = trimmed.startsWith('/') ? trimmed : `/${trimmed}`
  if (withLeading.startsWith('/maptac/')) {
    return withLeading.endsWith('/') ? withLeading : `${withLeading}/`
  }
  const body = withLeading.replace(/^\/+/, '')
  return `/maptac/${body}/`.replace(/\/+/g, '/')
}
